var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"text-uppercase white--text user-select-none",attrs:{"color":_vm.poStatusColor,"small":_vm.small}},[_vm._v(_vm._s(_vm.poStatusType.value))])
}
var staticRenderFns = []

export { render, staticRenderFns }